<template>
  <div class="app_content">
    <div class="wp">
      <indexTab></indexTab>
      <!-- 焦点图 开始 -->
      <div class="focusbg">
        <el-carousel ref="carousel" :indicator-position="'none'" :autoplay="true" arrow="always" class="el-carousel"
          @change="handleChange" :interval="4000">
          <el-carousel-item v-for="(item, index) in bannerData.slice(0,5)" :key="index">
            <div class="focus_item">
              <!-- <div class="arrowl" title="向左" id="pre_focuspic"></div> -->
              <img @click="goDetail(item)" :src="item.imgUrl" />
              <div>
                <h3> {{'第'+item.period+'期'}} </h3>
                <a @click="goDetail(item)">{{ item.title }}</a>
                <p>
                 {{ item.introduce }}
                 </p>
              </div>
              <!-- <div class="arrowr" title="向右" id="next_focuspic"></div> -->
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="focuslist">
          <p :class="{ 'current': (bannerIndex == index) }" v-for="(item, index) in bannerData.slice(0,5)" :key="index">
            <img @mouseenter="changes(index)"
            :src="item.imgUrl" />
          </p>
        </div>
      </div>
      <!-- 焦点图 结束 -->
    </div>
    <!-- 往期回顾 -->
    <div class="period">
      <p class="period_tit">往期回顾 <span @click="morewang()">更多</span></p>
      <ul>
        <li v-for="(item, index) in newsData" :key="index">
          <img @click="goDetail(item)" width="255" height="145"
            :src="item.imgUrl" />
          <a class="liTit" @click="goDetail(item)">{{ item.title }}</a>
          <p class="liCont">
            {{ item.abstractContent.slice(0,50) }}
            <span @click="goDetail(item)">[详细]</span>
          </p>
          <p class="paly">
            <span @click="goDetail(item)">点击观看</span>
          </p>
          <div v-if="index!=0&&index%3==0" class="dashed"></div>
        </li>
      </ul>
    </div>
    <!-- 政务微博 -->
    <div class="zhengwu">
      <p class="period_tit">政务微博</p>
      <object  data="https://widget.weibo.com/weiboshow/index.php?language=&width=0&height=540&fansRow=1&ptype=1&speed=0&skin=1&isTitle=1&noborder=1&isWeibo=1&isFans=0&uid=3514316985&verifier=06ea50e8&dpc=1" width="100%" height="550" type="text/html">
      </object>
      <p class="period_tit1">政务微博列表 <a @click="moreWeibo">更多</a></p>
      <ul class="wbimg"><!--微博列表s-->
          <li v-for="(item,index) in weiboList" :key="index">
          <a :href="item.jump" target="_blank">
            <img :src="item.img" width="50" height="50" border="0">
            <span>{{ item.title }}</span>
           </a>
          </li>
      </ul>
    </div>
    <!-- 底部 -->
    <bot></bot>
  </div>
</template>

<script>
import {
  indexBanner,//轮播图
  latestNews
} from "@/api/index.js";
import { myMixins } from "@/mixins/weibo.js";
export default {
  name: 'Index',
  mixins: [myMixins],
  data() {
    return {
      bannerData:[],
      newsData:[],
      bannerIndex: 0,   
    }
  },
  mounted() {
      this.indexBanner();
  },
  methods: {
    morewang(){
      window.open('/wangqi', "_blank");   
    },
    moreWeibo(){
      window.open('/weibo', "_blank");   
    },
    indexBanner(){
      indexBanner({}).then(res => {
        this.bannerData=res.data;
      })
      latestNews({}).then(res => {
        this.newsData=res.data;
      })
    },
    goDetail(item){
      window.open('/videoDetail?id='+item.articleId, "_blank");       
    },
    handleChange(val) {
      this.bannerIndex = val % 5;
    },
    changes(e) {
      this.$refs.carousel.setActiveItem(e) // 将tab的下标指定为走马灯的下标
      this.bannerIndex = e // tab切换的下标
    }
  }
}
</script>
<style lang="scss">
 .el-carousel__arrow{
    height: 56px;
    width: 40px;
    border-radius: 0;
    // background-color:rgba(0, 0, 0, 0) !important;
   &:first-child{
    width: 40px;
    height: 64px;
    border-radius: 0;
    left: 0;
    background: url('http://hfy-img.xzyunchuang.com/39a70904c5147dc087d5744892f69870') no-repeat 0 -354px;
   }
   &:nth-child(2){
    right: 0;
    width: 40px;
    height: 64px;
    border-radius: 0;
    background: url('http://hfy-img.xzyunchuang.com/39a70904c5147dc087d5744892f69870') no-repeat -40px -358px;
   }
   .el-icon-arrow-right{
    display: none;
   }
   .el-icon-arrow-left{
    display: none;
   }
   i{
    display: none;
    font-size: 0;
   }
   &:hover{
    // background: none;
   }
 }

</style>
<style scoped lang="scss">
.app_content {
  background: url('http://hfy-img.xzyunchuang.com/3b7506a84d68c5204b9f83fe021ca337') repeat-x top left;

  .wp {
    background: url('http://hfy-img.xzyunchuang.com/ec83463d52d1466d0c2b9874be5bb2a5') no-repeat top center;
    width: 100%;
    margin: 0 auto;
    .top {
      width: 960px;
      height: 403px;
      margin: 0 auto;
    }

    .menuBg {
      height: 54px;
      background: url('http://hfy-img.xzyunchuang.com/2ee32c4494bd64fe79d740200b4f8605') repeat-x top left;
      overflow: hidden;

      .menu {
        height: 54px;
        width: 960px;
        overflow: hidden;
        margin: 0 auto;
        color: #fff;

        li {
          color: #fff;
          display: inline-block;
          line-height: 54px;
          font-size: 14px;
          padding: 0 20px;
          position: relative;
          cursor: pointer;

          &::after {
            content: '';
            width: 2px;
            height: 96%;
            position: absolute;
            right: 0;
            top: 2%;
            background: linear-gradient(to right, #0e0e0e, #494949);
            box-shadow: 0px 0px 5px #424242;
          }

          &:hover {
            background: url('http://hfy-img.xzyunchuang.com/ece2396f22b904427aa71e922b759291');
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}

/deep/ .focusbg {
  min-width: 1000px;
  height: 452px;
  background: url('http://hfy-img.xzyunchuang.com/806af7825d10ea016e4f4755da16b1e2') repeat-x 0 -114px;

  .el-carousel {
    width: 1000px;
    overflow: hidden;
    margin: 0 auto;
    height: 350px;
  }

  .el-carousel__container {
    height: 350px;
  }

  .focus_item {
    display: flex;
    color: #fff;
    margin: 10px 0;
    padding: 0 70px;
    h3{
      margin: 0;
      padding: 0;
      font-size: 18px;
      line-height: 28px;
    }
    a {
      font-size: 16px;
      font-weight: 500;
      margin: 0;
      padding: 0;
      cursor: pointer;
      &:hover{
        border-bottom: 1px solid #fff;
      }
      // line-height: 30px;
    }

    div {
      margin-left: 16px;
    }

    p {
      color: #8db9f0;
      font-size: 14px;
      line-height: 24px;
      margin-top: 10px;
    }

    .arrowl {
      text-indent: -9999px;
      margin: 180px 25px 0 7px;
      cursor: pointer;
      display: inline;
      overflow: hidden;
      width: 36px;
      height: 60px;
      background: url('http://hfy-img.xzyunchuang.com/39a70904c5147dc087d5744892f69870') no-repeat 0 -357px;
    }

    .arrowr {
      text-indent: -9999px;
      margin: 180px 11px 0 0;
      cursor: pointer;
      display: inline;
      width: 36px;
      height: 60px;
      overflow: hidden;
      background: url('http://hfy-img.xzyunchuang.com/39a70904c5147dc087d5744892f69870') no-repeat -40px -358px;
    }

  }

  .focuslist {
    width: 823px;
    height: 96px;
    padding: 2px 20px;
    background: #143d6b;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    p {
      width: 129px;
      height: 70px;
      padding: 10px;
      cursor: pointer;
      padding: 6px 0 0 1px;
      margin: 12px 16px 0 18px;

      img {
        width: 126px;
        height: 67px;
        border: 1px solid #2b70bc;
      }
    }

    .current {
      background: url('http://hfy-img.xzyunchuang.com/39a70904c5147dc087d5744892f69870') no-repeat -139px -289px;

      img {
        border: 1px solid #fff;
      }
    }
  }
}

// 往期回顾
.period {
  margin: 20px auto;
  width: 960px;
  border: 1px solid #ccc;
  position: relative;
  &::after{
    content: '';
    width: 960px;
    position: absolute;
    left: 0;
    right: 0;
    height: 6px;
    bottom: -30px;
    border-top: 5px solid #666;
  }
  &_tit {
    font-family: '黑体';
    font-size: 26px;
    font-weight: bolder;
    color: #333;
    border-bottom: 1px solid #ccc;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      &:hover{
        border-bottom: 1px solid #046;
      }
    }
  }

  ul {
    li {
      display: inline-block;
      width: 255px;
      margin-left: 50px;
      margin-top: 20px;
      margin-bottom: 40px;
      position: relative;
      img {
        width: 255px;
      }

      .liTit {
        font-size: 14px;
        font-weight: bold;
        color: #046;
        cursor: pointer;
        &:hover{
          border-bottom: 1px solid #046;
        }
      }

      .liCont {
        color: #666;
        line-height: 20px;
        font-size: 14px;
        margin-top: 10px;

        span {
          color: #900;
          font-size: 14px;
          cursor: pointer;
          &:hover{
          border-bottom: 1px solid #900;
        }
        }
      }

      .paly {
        height: 16px;
        line-height: 16px;
        color: #fff;
        margin-top: 10px;
        font-size: 12px;
        padding: 0 8px 0 28px;
        // display: inline-block;
        float: right;
        cursor: pointer;
        background: #39f url('http://hfy-img.xzyunchuang.com/6f8684a9cd088fbdf4b317af3f969f92') left top no-repeat;
      }
      .dashed{
        position: absolute;
        left: 0;
        top: -30px;
        width: 865px;
        border-top: 1px dashed #ccc;
      }
    }
  }
}
.zhengwu{
  margin: 30px auto 20px auto;
  width: 960px;
  padding-bottom: 18px;
  border-bottom: 5px solid #666;
  &_tit {
    font-family: '黑体';
    font-size: 26px;
    font-weight: bolder;
    color: #333;
    border-bottom: 1px solid #ccc;
    padding: 16px 20px;
  }
  .period_tit1{
    border-top: 2px dashed #ccc;
    line-height: 36px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    a{
      color: #333;
      text-decoration: none;
      cursor: pointer;
      &:hover{
        color: #0078B6;
        text-decoration: underline;
      }
    }
  }
  ul{
    display: flex;
    flex-flow: wrap;
    li{
      margin: 0 0 5px 5px;
      width: 55px;
    }
    a{
      text-decoration: none;
    }
    span{
      display: block;
      color: #0078B6;
      font-size: 12px;
      height: 20px;
      width: 50px;
      overflow: hidden;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/index/index.vue